export const erroren = {
  en: {
    messages: {
      ext: () => 'Only PDF, DOC, and DOCX allowed',
      min: (name, ref) => 'Minimum characters of ' + (!isNaN(name[name.length - 2]) ? name.slice(0, - 2) : (!isNaN(name[name.length -1]) ? name.slice(0, -1) : name)) + ' is ' + ref[0],
      max: (name, ref) => 'Maximum characters of ' + (!isNaN(name[name.length - 2]) ? name.slice(0, - 2) : (!isNaN(name[name.length -1]) ? name.slice(0, -1) : name)) + ' is ' + ref[0],
      required: (name) => (!isNaN(name[name.length - 2]) ? name.slice(0, - 2) :  (!isNaN(name[name.length -1]) ? name.slice(0, -1) : name)) + ' is a required field.',
      excluded: (name) => (!isNaN(name[name.length - 2]) ? name.slice(0, - 2) :  (!isNaN(name[name.length -1]) ? name.slice(0, -1) : name)) + ' is a required field.',
      included: (name) => (!isNaN(name[name.length - 2]) ? name.slice(0, - 2) :  (!isNaN(name[name.length -1]) ? name.slice(0, -1) : name)) + ' is a required field.',
    }
  }
};

export default erroren;



//////////////////
// WEBPACK FOOTER
// ./static/resources/Errors/error-en.js
// module id = 6SmW
// module chunks = 39